import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { BasicCameraPanel } from 'page/ProfileScreen/BasicSelfiesPanel/BasicCameraPanel'

export const FirstStep = observer(() => {
  return (
    <Vertical gap={40}>
      <Vertical>
        <Typo size={24} tertiary upper center>
          {i18n('StepCount', { count: 1 })}
        </Typo>
        <Typo size={32} medium upper center>
          {i18n('TakeSelfie')}
        </Typo>
      </Vertical>
      <BasicCameraPanel />
    </Vertical>
  )
})
